module.exports = __webpack_public_path__ + "img/utilities.9218595d.png";